(function () {
  'use strict';

  const MOBILE_MQ = window.matchMedia('(max-width: 749px)');
  const TABLET_MQ = window.matchMedia('(min-width: 750px) and (max-width: 989px)');

  function getPerView() {
    if (MOBILE_MQ.matches) return 1;
    if (TABLET_MQ.matches) return 2;
    return 0;
  }

  function getPageCount(slideCount, perView) {
    return Math.ceil(slideCount / perView);
  }

  function getDots(slider, perView) {
    if (perView === 1) {
      return slider.querySelectorAll('[data-oz-features-dots="mobile"] [data-oz-features-dot]');
    }
    if (perView === 2) {
      return slider.querySelectorAll('[data-oz-features-dots="tablet"] [data-oz-features-dot]');
    }
    return [];
  }

  function getActivePage(track, slides, perView) {
    if (!slides.length || !perView) return 0;

    const trackWidth = track.clientWidth;
    if (!trackWidth) return 0;

    if (perView === 1) {
      const scrollCenter = track.scrollLeft + trackWidth / 2;
      let closest = 0;
      let minDistance = Infinity;

      slides.forEach((slide, index) => {
        const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        const distance = Math.abs(scrollCenter - slideCenter);
        if (distance < minDistance) {
          minDistance = distance;
          closest = index;
        }
      });

      return closest;
    }

    const page = Math.round(track.scrollLeft / trackWidth);
    const maxPage = getPageCount(slides.length, perView) - 1;
    return Math.max(0, Math.min(page, maxPage));
  }

  function initSlider(slider) {
    const track = slider.querySelector('[data-oz-features-track]');
    const slides = slider.querySelectorAll('.oz-feature-item');

    if (!track || slides.length <= 1) return;

    function setActive(pageIndex) {
      const perView = getPerView();
      const dots = getDots(slider, perView);
      if (!dots.length) return;

      const maxPage = getPageCount(slides.length, perView) - 1;
      const safeIndex = Math.max(0, Math.min(pageIndex, maxPage));

      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === safeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    function scrollToPage(pageIndex) {
      const perView = getPerView();
      if (!perView) return;

      const slideIndex = pageIndex * perView;
      const slide = slides[slideIndex];
      if (!slide) return;

      track.scrollTo({
        left: slide.offsetLeft,
        behavior: 'smooth',
      });
      setActive(pageIndex);
    }

    function syncFromScroll() {
      const perView = getPerView();
      if (!perView) return;
      setActive(getActivePage(track, slides, perView));
    }

    function bindDots() {
      slider.querySelectorAll('[data-oz-features-dot]').forEach((dot) => {
        if (dot.dataset.bound === 'true') return;
        dot.dataset.bound = 'true';
        dot.addEventListener('click', () => {
          scrollToPage(Number(dot.dataset.index));
        });
      });
    }

    function onBreakpointChange() {
      const perView = getPerView();
      if (perView) {
        syncFromScroll();
      } else {
        track.scrollLeft = 0;
        setActive(0);
      }
    }

    bindDots();
    track.addEventListener('scroll', syncFromScroll, { passive: true });

    if ('onscrollend' in window) {
      track.addEventListener('scrollend', syncFromScroll, { passive: true });
    }

    MOBILE_MQ.addEventListener('change', onBreakpointChange);
    TABLET_MQ.addEventListener('change', onBreakpointChange);

    setActive(0);
  }

  function boot(root) {
    (root || document).querySelectorAll('[data-oz-features-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    boot(event.target);
  });
})();
